import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import BenefitsSection from '../../components/feature/BenefitsSection';
import ProcessSection from '../../components/feature/ProcessSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import CTASection from '../../components/feature/CTASection';
import ContactSection from '../../components/feature/ContactSection';
import MapSection from '../../components/feature/MapSection';

export default function About() {
  return (
    <div className="min-h-screen bg-white pb-16 lg:pb-0">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-screen flex items-center justify-center">
        <div className="absolute inset-0">
          <img src="https://public.readdy.ai/ai/img_res/e7a7c87c558674edde7315066ff83a45.jpg" alt="Dr. Robin Ellen Leder MD integrative medicine physician Hackensack NJ" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(5,30,25,0.93) 0%, rgba(10,60,48,0.80) 45%, rgba(10,60,48,0.30) 100%)' }}></div>
        </div>
        <div className="relative z-10 w-full px-6 lg:px-12 pt-24">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="inline-block w-8 h-px bg-amber-400"></span>
              <p className="text-amber-400 text-xs font-bold tracking-widest uppercase">Board-Certified MD · Hackensack, NJ · 40+ Years</p>
            </div>
            <h1 className="font-heading text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Dr. Robin Ellen Leder, MD
            </h1>
            <p className="text-teal-100 text-xl mb-8 leading-relaxed">Four decades of root-cause functional medicine, advanced hormone therapy, IV chelation, and integrative psychiatry — trusted by thousands of Bergen County patients.</p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a href="tel:2015251155" className="flex items-center justify-center gap-2 bg-white text-teal-900 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-teal-700 text-base"></i></div>
                Call (201) 525-1155
              </a>
              <Link to="/contact" className="flex items-center justify-center gap-2 border-2 border-white text-white px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-white hover:text-teal-900 transition-colors cursor-pointer whitespace-nowrap">
                Book Free Consultation
              </Link>
            </div>
            <div className="flex flex-wrap gap-4">
              {['40+ Years Experience','Board-Certified MD','IV & Chelation Specialist','Orthomolecular Psychiatry'].map(t => (
                <div key={t} className="flex items-center gap-2 bg-teal-900/50 border border-teal-700 rounded px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-shield-check-fill text-amber-400 text-sm"></i></div>
                  <span className="text-teal-100 text-xs font-medium">{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <TrustBar />

      {/* Doctor Bio */}
      <section className="py-20 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
            <div>
              <div className="relative rounded-lg overflow-hidden">
                <img src="https://images.squarespace-cdn.com/content/v1/589c8fe215d5db3ff221932d/48a78432-3663-46c4-a5f9-e10d46408033/045%5B1%5D+%283%29.jpg" alt="Dr. Robin Ellen Leder MD holistic functional medicine Hackensack NJ" className="w-full h-auto" />
                <div className="absolute inset-0 bg-gradient-to-t from-teal-950/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="font-heading font-bold text-white text-lg">Dr. Robin Ellen Leder, MD</p>
                  <p className="text-teal-300 text-sm">40+ Years · Hackensack, NJ · Functional & Integrative Medicine</p>
                </div>
              </div>
              <div className="mt-4 bg-teal-50 border border-teal-100 rounded-lg p-5">
                <p className="text-xs font-bold text-teal-600 tracking-widest uppercase mb-3">Credentials & Expertise</p>
                <div className="space-y-2">
                  {['MD — Board-Certified Physician','40+ Years Functional & Integrative Medicine','Orthomolecular Psychiatry & Psychology','IV Chelation & Nutrient Therapy Specialist','Hormone & Endocrine Health Expert','Monthly Author — Bergen County Health Publications','Founder, A Better Alternative Medical Center'].map(c => (
                    <div key={c} className="flex items-start gap-2 text-sm text-teal-800">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0"><i className="ri-checkbox-circle-fill text-teal-600 text-sm"></i></div>
                      {c}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="space-y-5">
              <div>
                <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Her Story</p>
                <h2 className="font-heading text-4xl font-bold text-teal-950 mb-6 leading-tight">A Doctor Who Works With You, Not Above You</h2>
              </div>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>From your very first 10-minute consultation, you know this experience is different. Dr. Robin Ellen Leder brings a rare combination of 40+ years of medical expertise, deep compassion, and investigative curiosity to every patient encounter.</p>
                <p>For four decades at A Better Alternative Medical Center in Hackensack, NJ, Dr. Leder has been the practitioner patients turn to when conventional medicine has exhausted its answers. Her practice is a sanctuary for those seeking serious medical investigation through in-depth review of personal health, lifestyle, and biochemical status.</p>
                <p>She takes extended time with every patient — digging into root causes, designing fully personalized protocols, and always honoring patient requests for specific testing. Doctor and patient work together as true partners in healing.</p>
                <p>Dr. Leder also brings a unique background in psychology and orthomolecular psychiatry, offering counseling for individuals, couples, and families, and providing natural alternatives to psychiatric medications through nutritional and functional medicine.</p>
                <p className="font-semibold text-teal-900 text-lg italic font-heading">"If you're looking for someone who blends traditional knowledge with modern functional medicine — someone who genuinely cares — Dr. Leder may be exactly who you've been searching for."</p>
              </div>
              <div className="grid grid-cols-3 gap-4 pt-4">
                {[['40+','Years Practice'],['12','Programs'],['Bergen Co.','Top-Rated']].map(([n, l]) => (
                  <div key={l} className="bg-teal-50 border border-teal-100 rounded-md p-4 text-center">
                    <p className="font-heading text-2xl font-bold text-teal-800">{n}</p>
                    <p className="text-teal-600 text-xs">{l}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection variant="mid" />
      <ServicesGrid compact />
      <AIAnswerBlock page="about" />
      <BenefitsSection />
      <CTASection variant="mid" />
      <ProcessSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection variant="bottom" />
      <ContactSection />
      <MapSection />
      <Footer />
    </div>
  );
}
